var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgClock(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 12,
    viewBox: "0 0 7 6",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.01911 1.28571C4.01911 1.1437 3.90398 1.02857 3.76196 1.02857C3.61995 1.02857 3.50482 1.1437 3.50482 1.28571V3C3.50482 3.08866 3.55049 3.17107 3.62568 3.21806L4.65425 3.86091C4.77468 3.93618 4.93332 3.89957 5.00859 3.77914C5.08386 3.65871 5.04725 3.50007 4.92682 3.4248L4.01911 2.85748V1.28571Z",
    fill: "#4F55A6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.76196 0C2.10511 0 0.761963 1.34315 0.761963 3C0.761963 4.65685 2.10511 6 3.76196 6C5.41882 6 6.76196 4.65685 6.76196 3C6.76196 1.34315 5.41882 0 3.76196 0ZM1.27625 3C1.27625 1.62718 2.38914 0.514286 3.76196 0.514286C5.13479 0.514286 6.24768 1.62718 6.24768 3C6.24768 4.37282 5.13479 5.48571 3.76196 5.48571C2.38914 5.48571 1.27625 4.37282 1.27625 3Z",
    fill: "#4F55A6"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClock);
export default __webpack_public_path__ + "static/media/clock.4e896e24e01784313dc532c117b4359d.svg";
export { ForwardRef as ReactComponent };